import PropTypes from 'prop-types';
import React from 'react';
import { Container, Dimmer, Grid, Loader, Segment } from 'semantic-ui-react';

import * as styles from './MessagePage.less';

const MessagePage = props => {
  const { message } = props;

  return message == 'Loading' ? (
    <Container>
      <Dimmer active inverted>
        <Loader inverted>Loading</Loader>
      </Dimmer>
    </Container>
  ) : (
    <Container>
      <Grid centered padded>
        <Grid.Row>{message}</Grid.Row>
      </Grid>
    </Container>
  );
};

MessagePage.propTypes = {
  children: PropTypes.string,
  message: PropTypes.any,
};

export default MessagePage;



// WEBPACK FOOTER //
// ./src/views/pages/MessagePage/MessagePage.js